import { ElementsIconProps } from '../components';

export function CheckListFilledIcon(props: ElementsIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="text-current"
      {...props}
    >
      <g id="fact_check-24px">
        <path
          id="Shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.0005 3H4.00049C2.90049 3 2.00049 3.9 2.00049 5V19C2.00049 20.1 2.90049 21 4.00049 21H20.0005C21.1005 21 22.0005 20.1 22.0005 19V5C22.0005 3.9 21.1005 3 20.0005 3ZM9.00049 17H6.00049C5.45049 17 5.00049 16.55 5.00049 16C5.00049 15.45 5.45049 15 6.00049 15H9.00049C9.55049 15 10.0005 15.45 10.0005 16C10.0005 16.55 9.55049 17 9.00049 17ZM9.00049 12.9999H6.00049C5.45049 12.9999 5.00049 12.5499 5.00049 11.9999C5.00049 11.4499 5.45049 10.9999 6.00049 10.9999H9.00049C9.55049 10.9999 10.0005 11.4499 10.0005 11.9999C10.0005 12.5499 9.55049 12.9999 9.00049 12.9999ZM9.00049 9.00012H6.00049C5.45049 9.00012 5.00049 8.55012 5.00049 8.00012C5.00049 7.45012 5.45049 7.00012 6.00049 7.00012H9.00049C9.55049 7.00012 10.0005 7.45012 10.0005 8.00012C10.0005 8.55012 9.55049 9.00012 9.00049 9.00012ZM18.7007 11.1201L15.5307 14.2901C15.1407 14.6801 14.5007 14.6801 14.1107 14.2901L12.7007 12.8701C12.3107 12.4801 12.3107 11.8501 12.7007 11.4601C13.0907 11.0701 13.7207 11.0701 14.1107 11.4601L14.8207 12.1701L17.2907 9.70009C17.6807 9.31009 18.3107 9.31009 18.7007 9.70009L18.7107 9.71009C19.0907 10.1001 19.0907 10.7401 18.7007 11.1201Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
